/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface WorkflowItemHistory { 
    id?: string;
    workflow_item_id?: string;
    changed_code?: number;
    old_data?: string;
    new_data?: string;
    created_at?: Date;
    created_by?: string;
}